import createReactClass from 'create-react-class';
'use strict';

// Import Libraries
import React from 'react';

// -----------------------------------------------------------
//  Breadcrumb
// -----------------------------------------------------------
var Breadcrumb = createReactClass({
  render: function(){
    return  <nav aria-label='breadcrumbs'>
              <ol className='breadcrumb'>
               {
                 (this.props.segments || []).map(function(segment, i){
                    if (segment.url) {
                      return  <li className="breadcrumb-item" key={ i }>
                                { renderLink(segment) }
                              </li>;
                    } else {
                      return  <h1 className="breadcrumb-item active" key={ i }>
                                { this.props.title || segment.name }
                              </h1>;
                    }
                 }, this)
               }
             </ol>
           </nav>;

    function renderLink(segment){
      return <a href={ segment.url }>{ segment.name }</a>;
    }
  }
});

export default Breadcrumb;
